import React, { Fragment, useState } from 'react';
import styled from 'styled-components/native';
import ListItem from '../../../../components/list/ListItem';
import ListItemIcon from '../../../../components/list/ListItemIcon';
import ListItemText from '../../../../components/list/ListItemText';
import Spacer from '../../../../components/Spacer';
import { H5 } from '../../../../components/Typography';
import Colors from '../../../../constants/Colors';
import {
  ScreenComponentPlugin,
  ScreenComponentProps
} from '../ScreenComponentPlugin';
import StudyIntroModal from '../../../modals/StudyIntroModal';

const StyledContainerView = styled.View`
  padding-top: 8px;
`;

const StyledRectangleImage = styled.Image`
  height: 43.29px;
  width: 49px;
  border-radius: 8px;
`;

interface StudyListDisplayItem {
  studyId?: number;
  title?: string;
  imageUrl?: string;
  description?: string;
}

interface StudyListProps {
  title?: string;
  studyList?: StudyListDisplayItem[];
}

const StudyList: React.FC<ScreenComponentProps<StudyListProps>> = ({
  title = 'List Title',
  studyList = []
}) => {
  const [selectedStudyId, setSelectedStudyId] = useState<number>();
  const [selectedStudyTitle, setSelectedStudyTitle] = useState<string>();
  return (
    <StyledContainerView>
      <H5 color='dark'>{title}</H5>
      <Spacer size={2} />
      {studyList.map((item, index) => (
        <Fragment key={index}>
          <ListItem
            framed
            divider
            filled
            onPress={() => {
              setSelectedStudyId(item.studyId);
              setSelectedStudyTitle(item.title);
            }}
          >
            <ListItemText
              primary={item.title || 'Study Name'}
              primaryTextColor={Colors.secondaryText}
              largeSecondary={item.description}
              secondaryTextColor={'#5B4FC2'}
            />
            <ListItemIcon iconPosition='right'>
              <StyledRectangleImage
                resizeMode='contain'
                source={{ uri: item.imageUrl }}
              />
            </ListItemIcon>
          </ListItem>
          <Spacer />
        </Fragment>
      ))}
      {selectedStudyId && (
        <StudyIntroModal
          title={selectedStudyTitle}
          studyId={selectedStudyId}
          visible
          onClose={() => setSelectedStudyId(undefined)}
          onRequestClose={() => setSelectedStudyId(undefined)}
        />
      )}
    </StyledContainerView>
  );
};

export const StudyListPlugin: ScreenComponentPlugin<StudyListProps> = {
  type: 'StudyList',
  name: 'Study List',
  categories: ['join'],
  component: StudyList
};
